module.exports = __webpack_public_path__ + "img/metal_ad@2x.eb2d348a.png";